import { createSlice, Dispatch } from '@reduxjs/toolkit';
// utils
import { CreateTaxRateDto, EditTaxRateDto, TaxRateDto, TaxSettingsService } from '../../api';
import { setError } from './error';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null as any,
  taxRates: [{}] as TaxRateDto[],
};

const slice = createSlice({
  name: 'tax',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TAX RATES
    getTaxRatesSuccess(state, action) {
      state.taxRates = action.payload;
    },

    // GET TAX RATE
    getTaxRateSuccess(state, action) {
      if (state.taxRates.find((tx) => tx.id === action.payload.id) === undefined) {
        state.taxRates.push(action.payload);
      }
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getTaxRates() {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await TaxSettingsService.getTaxRates();
      dispatch(slice.actions.getTaxRatesSuccess(response));
    } catch (error) {
      dispatch(setError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getTaxRate(id: number[]) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response: TaxRateDto[] = await TaxSettingsService.getTaxRate({ body: id });
      response.forEach((tx) => dispatch(slice.actions.getTaxRateSuccess(tx)));
    } catch (error) {
      dispatch(setError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function checkTaxRatAccount(id: number) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await TaxSettingsService.checkTaxRateAccount({ id });
      return response;
    } catch (error) {
      dispatch(setError(error));
    }
    return false;
  };
}

// ----------------------------------------------------------------------

export function addTaxEntity(query: CreateTaxRateDto) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await TaxSettingsService.addTaxRates({
        body: query,
      });
    } catch (error) {
      dispatch(setError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function editTaxEntity(data: EditTaxRateDto) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    await TaxSettingsService.editTaxRates({
      body: data,
    });
  };
}

// ----------------------------------------------------------------------

export function removeTaxEntity(id: number) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    await TaxSettingsService.removeTaxRates({
      id,
    });
  };
}

// ----------------------------------------------------------------------

export function setTaxError(data: any) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.hasError({ ...data }));
  };
}

// ----------------------------------------------------------------------

export function resetTaxError() {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.hasError(null));
  };
}
